import React from 'react';
import { Card } from '@material-ui/core';

import Content from 'src/components/Content';
import EngagementsLedger from './EngagementsLedger';


function ListEngagements() {
  return (
    <Content title="All engagements" maxWidth="lg">
      <Card>
        <EngagementsLedger />
      </Card>
    </Content>
  );
}

export default ListEngagements;
